import { Check, Sparkles, Star } from "lucide-react";
import { Link } from "react-router-dom";

const ICONS = { 1: Sparkles, 2: Star, 3: Star, 4: Star };

export function PackageCard({ pkg, selected, onSelect, compact = false, chooseHref, introPrice }) {
  const Icon = ICONS[pkg.tier] || Sparkles;
  const featured = pkg.tier === 3;
  const showIntro = pkg.intro && introPrice != null && Number(introPrice) < Number(pkg.price);
  return (
    <div
      data-testid={`package-card-${pkg.id}`}
      onClick={() => onSelect && onSelect(pkg)}
      className={[
        "group relative flex w-full flex-col rounded-3xl border p-6 text-left transition-transform hover:-translate-y-1",
        onSelect ? "cursor-pointer" : "",
        selected ? "border-[#F4D03F] bg-white ring-4 ring-[#F4D03F]/40" : "border-[rgba(74,35,90,0.12)] bg-white",
        featured ? "shadow-[0_12px_44px_rgba(74,35,90,0.14)]" : "shadow-[0_8px_32px_rgba(74,35,90,0.06)]",
      ].join(" ")}
    >
      {pkg.intro && (
        <span className="absolute -top-3 left-6 rounded-full bg-[#F4D03F] px-3 py-1 text-xs font-extrabold text-[#1A0F1C]">
          INTRO OFFER
        </span>
      )}
      {featured && (
        <span className="absolute -top-3 right-6 rounded-full bg-[#9B5DE5] px-3 py-1 text-xs font-extrabold text-white">
          MOST LOVED
        </span>
      )}
      <div className="mb-3 flex items-center gap-2">
        <span className="grid h-9 w-9 place-items-center rounded-full bg-[#4A235A]/10 text-[#9B5DE5]">
          <Icon size={18} />
        </span>
        <h3 className="font-display text-xl font-bold text-[#4A235A]">{pkg.name}</h3>
      </div>
      <div className="mb-3 flex items-end gap-2">
        {showIntro ? (
          <>
            <span className="font-display text-4xl font-black text-[#1A0F1C]">${Number(introPrice).toFixed(0)}</span>
            <span className="mb-1 text-lg font-bold text-[#5C4A61] line-through">${Number(pkg.price).toFixed(0)}</span>
            <span className="mb-1 text-xs font-bold text-[#9B5DE5]">first character</span>
          </>
        ) : (
          <>
            <span className="font-display text-4xl font-black text-[#1A0F1C]">${Number(pkg.price).toFixed(0)}</span>
            <span className="mb-1 text-sm font-bold text-[#5C4A61]">one-time</span>
          </>
        )}
      </div>
      {!compact && <p className="mb-4 text-sm font-medium leading-relaxed text-[#5C4A61]">{pkg.description}</p>}
      {showIntro && !compact && (
        <p className="mb-3 text-xs font-semibold text-[#5C4A61]">Eligibility for the $1 first-character offer is checked before checkout.</p>
      )}
      <ul className="mt-auto space-y-2">
        {(pkg.features || []).map((f) => (
          <li key={f} className="flex items-start gap-2 text-sm font-semibold text-[#3B1C4A]">
            <Check size={16} className="mt-0.5 shrink-0 text-[#9B5DE5]" />
            {f}
          </li>
        ))}
      </ul>
      {chooseHref && (
        <Link
          to={chooseHref}
          data-testid={`choose-pack-${pkg.id}`}
          className="mt-5 inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full bg-[#4A235A] px-6 font-extrabold text-white transition-transform hover:-translate-y-0.5"
        >
          Choose this pack
        </Link>
      )}
    </div>
  );
}
